import { Link } from "react-router-dom";

function CarCard({ car }) {

  return (
    <div className="card" data-aos="zoom-in">

      <img
        src={car.image}
        alt={car.name}
      />

      <div className="card-body">

        <h3>{car.name}</h3>

        <p>{car.price}</p>

        <Link to={`/car/${car.id}`}>

          <button>
            View Details
          </button>

        </Link>

      </div>

    </div>
  );
}

export default CarCard;